import { render, staticRenderFns } from "./LanguageResources.vue?vue&type=template&id=2d3abc81"
import script from "./LanguageResources.vue?vue&type=script&lang=ts"
export * from "./LanguageResources.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports